import globalValues from '@/core/helpers/enums/globalValues';
import i18n from '@/i18n';
import { http } from '@/utils/http.util';

export default class candidateService {
   async getSubmissionById(id: string) {
      return await http
         .get('/api/submission/' + id, {
            params: {
               include:
                  'candidate_steps.answers.module,candidate_steps.answers.media,journey.steps.modules.sort_choices_by,entry_referral.journey_team.team.tenant,journey.customer,addresses.address_type,addresses.city.country',
            },
         })
         .then((response) => {
            return response.data;
         });
   }

   async postCandidateStep(candidateStep: Object) {
      return await http
         .post('/api/candidate-step', candidateStep, {
            params: { include: 'step,answers' },
         })
         .then((response) => {
            return response.data;
         });
   }

   async patchCandidateStep(id: Number, candidateStep: Object, submission_random: string) {
      return await http
         .patch('/api/candidate-step/' + id, candidateStep, {
            headers: {
               'submission-random': submission_random,
            },
         })
         .then((response) => {
            return response.data;
         });
   }

   async getCandidateStepById(id: Number) {
      return await http
         .get('/api/candidate-step/' + id, {
            headers: {
               'submission-random': sessionStorage.getItem(globalValues.candidate.journeyRandom),
            },
            params: {
               include: 'answers,step',
            },
         })
         .then((response) => {
            return response.data;
         })
         .catch(() => {
            throw Error(i18n.global.t('error.couldNotFetchStep'));
         });
   }

   async patchSubmission(id: Number, submission: Object) {
      return await http.patch('/api/submission/' + id, submission).then((response) => {
         return response.data;
      });
   }

   async getSubmissionNextStep(id: String) {
      return await http.get('/api/submission/' + id + '/next-step').then((response) => {
         return response.data;
      });
   }

   async getCandidateAttributes(stepId: Number, moduleId: Number) {
      return await http.get(`/api/candidate-step/${stepId}/module/${moduleId}/attribute-values`).then((response) => {
         return response.data;
      });
   }
   async postSubmissionOccurence(submissionId: Number, submission_random: string, comment?: string, submissionStateKey?: string) {
      return await http
         .post(
            '/api/submission-occurrence',
            {
               submission_id: submissionId,
               comment: comment,
               submission_state_key: submissionStateKey,
            },
            {
               headers: {
                  'submission-random': submission_random,
               },
            },
         )
         .then((response) => {
            return response.data;
         });
   }
}
